module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    on: {
      "click:outside": _vm.closeDialog
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    style: ({
      'color': _vm.theme
    })
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), _c('hr', {
    staticStyle: {
      "width": "100%",
      "border": "solid",
      "border-color": "rgba(0, 0, 0, 0.12)",
      "border-width": "thin 0 0 0"
    }
  })]), _vm._v(" "), _c('v-card-text', [(_vm.filterItems) ? _c('v-row', {
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 0px 10px"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "attach": ""
    },
    on: {
      "change": _vm.selectedChangeHandler
    },
    model: {
      value: (_vm.selectedCampaignFilter),
      callback: function($$v) {
        _vm.selectedCampaignFilter = $$v
      },
      expression: "selectedCampaignFilter"
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 0px 10px"
    }
  }, [_c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterItems,
      "label": "Filter",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "attach": ""
    },
    on: {
      "change": _vm.selectedChangeHandler
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.DataTableHeaders,
      "items": _vm.DataItems,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.totalPayouts",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(item.totalPayouts) + "/" + _vm._s(item.totalPosts) + "\n                      ")]
      }
    }, {
      key: "item.yetToPayouts",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(item.yetToPayouts) + "/" + _vm._s(item.totalPosts) + "\n                      ")]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.avgArray), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      attrs: {
        "id": "avgTitle"
      }
    }, [_vm._v(_vm._s(item.title) + ": "), _c('span', {
      attrs: {
        "id": "avg"
      }
    }, [_vm._v(" " + _vm._s(item.avg))])])])
  }), 0)], 1), _vm._v(" "), (_vm.type === 'duration') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('div', {
    staticClass: "teamTitle"
  }, [_vm._v("Team")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Activation: " + _vm._s(_vm.total.activation))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Pairing: " + _vm._s(_vm.total.pairing))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("CO-Creating: " + _vm._s(_vm.total.creating))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Completion: " + _vm._s(_vm.total.complete))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Overall Average: " + _vm._s(_vm.total.overall))])])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "color": _vm.theme,
      "large": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n                OK\n            ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06fda34d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/SeeMoreModal.vue
// module id = 1983
// module chunks = 0